/**
 * loại chương trình dự án
 */
export default {
  // Target: 1, //'Chương trình mục tiêu',
  // Project: 2, // 'Dự án',
  Construction: 3, // Công trình
  WorkItem: 4, // Hạng mục công trình
};
